import React from "react";
export function Button({ text, onClick, bgColor, size = "lg", textColor = "text-white", borderColor = "border-primary", type, disabled = false }) {
    return (React.createElement("button", { type: type, onClick: () => onClick(), disabled: disabled, className: `min-w-max  w-full ${size === "sm" ? "h-8" : size === "md" ? "h-9" : size === "lg" ? "h-10" : "h-12"} px-4  ${bgColor} ${textColor} border ${borderColor} font-semibold text-sm rounded-full cursor-pointer transition-all
      ${bgColor === "bg-primary"
            ? "hover:bg-[#23437c] hover:shadow-[0px_0px_0px_2px_rgb(156_181_227)]"
            : bgColor === "bg-secondary"
                ? "hover:shadow-[0px_0px_0px_2px_rgb(255_168_109)]"
                : bgColor === "bg-white"
                    ? "hover:shadow-[0px_0px_0px_2px_rgb(156_181_227)]"
                    : ""}
        ${disabled && "opacity-70"}
              ` }, text));
}
